import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vdsn2grmc4: FaireBrandEntity = {
  token: "b_vdsn2grmc4",
  type: "brand",
  name: "MommaBear Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/91c1c13821cd60d5a5c47bedbb17fb70ed78762e8efba56dcd3f451eee8e3569.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1af456f964d1a70cb21432b16393777bda3f325f3df3cae3d538a924d4ee142f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/91c1c13821cd60d5a5c47bedbb17fb70ed78762e8efba56dcd3f451eee8e3569.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1af456f964d1a70cb21432b16393777bda3f325f3df3cae3d538a924d4ee142f.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a women-led startup building conscientious, carefully crafted, delicious tasting homeopathic solutions for common ailments that the whole family can enjoy. We care deeply about our customers and giving back to our community.\n\nAbout our Founder: Soraya Benitez\n\nI was born and raised in Queens, New York. While there is so much to love about this city, air quality is not one of them. Common ailments are simply unavoidable.\n\nGrowing up, we didn't have a lot. But we had wonderful, caring parents who raised us with many of the botanic traditions common to their homeland of Colombia. Whether it was chamomile and ginger for an upset stomach or honey and lemon for sore throats, our pantry was always stocked full of herbs and our fridge full of fruits and veggies. They were always ready with home remedies to help us mend.\n\nNow, as a (tired) mom myself, I try to honor their herbal wisdom, love and care. I hope to pass along these traditions to my children...and now to you through MommaBear. Our tasty, single-dose lollipops are packed with antioxidants and other beneficial ingredients to deliciously ease the everyday ailments of those you love.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:56.815Z",
    importedBy: "entity-db-cli",
  },
};
